import * as React from 'react';
import './LoadingContainer.css';


class LoadingContainer extends React.Component<{}, {}> {
    render() {
        return (
            <div className={"loading-spinner"} />
        );
    }
}

export default LoadingContainer;
